export default {
  TOGGLE_SELECTION_MODE: 'toggleSelectionMode',
  TOGGLE_SELECTION_ID: 'toggleSelectionId',
  CLEAR_SELECTED_IDS: 'clearSelectedIds',
  SET_SELECTED_IDS: 'setSelectedIds',
};
